import { DateRange } from 'react-day-picker';
import { zonedTimeToUtc } from 'date-fns-tz';

export const zonedDateRangeToUtc = (
  dateRange: DateRange | undefined,
  timeZone: string
): DateRange | undefined => {
  if (!dateRange) {
    return undefined;
  }

  const from = dateRange.from
    ? zonedTimeToUtc(dateRange.from, timeZone)
    : undefined;
  const to = dateRange.to ? zonedTimeToUtc(dateRange.to, timeZone) : undefined;

  return { from, to };
};
